import styled from 'styled-components'

export const Title = styled.div`
  font-weight: 700;
  font-size: 20px;
  margin-bottom: 16px;
`

export const Description = styled.div`
  font-weight: 400;
  color: #000000;
  margin-bottom: 24px;
`
